import React from "react";
import { VakLastTestResponse } from "../../typings/vak";
import VakLastTest from "./VakLastTest";
import { Card } from "../UI/Card";
import Button from "../UI/Button";
import { Play, Sparkles } from "lucide-react";

interface VakTestIntroProps {
  loading: boolean;
  lastTest: VakLastTestResponse | null;
  onStartTest: () => void;
  onViewLastTestDetail: () => void;
}

const VakTestIntro: React.FC<VakTestIntroProps> = ({
  loading,
  lastTest,
  onStartTest,
  onViewLastTestDetail,
}) => {
  return (
    <div className="riasec-container p-3">
      <div className="w-full">
        <div className="flex flex-wrap">
          <div className="w-full">
            <h5 className="text-2xl font-bold mb-4 text-center text-foreground">
              Kelase LearningDNA
            </h5>
            <Card className="p-4">
              <div className="flex items-center gap-3 mb-4 text-primary">
                <Sparkles className="w-6 h-6" />
                <h6 className="font-bold text-lg">
                  Kenali cara belajarmu yang paling efektif.
                </h6>
              </div>
              <p className="text-gray-700 text-justify mb-3">
                Setiap siswa punya pola belajar yang unik.{" "}
                <strong>Kelase LearningDNA</strong> membantu kamu memahami
                bagaimana kamu belajar paling optimal apakah melalui visual,
                diskusi, praktik, atau kombinasi semuanya. Hasilnya akan jadi
                dasar rekomendasi belajar dan pengembangan karier yang lebih
                tepat untukmu
              </p>
              <div className="p-4 rounded border bg-blue-50 border-blue-200 text-blue-800">
                <strong>Yang Akan Kamu Dapatkan:</strong>
                <ul className="mb-0 mt-2 list-disc list-outside pl-4">
                  <li>Profil gaya belajar personal (mudah dipahami)</li>
                  <li>Rekomendasi cara belajar yang cocok untuk kamu</li>
                  <li>Insight awal untuk pilihan belajar & karier ke depan</li>
                </ul>
              </div>
              <div className={"w-full flex justify-center mt-5"}>
                <Button
                  primary
                  block
                  className="gradient-primary text-lg font-semibold text-sm"
                  onClick={onStartTest}
                  disabled={loading}
                >
                  <Play />{" "}
                  {loading ? "Memuat..." : "Mulai Tes LearningDNA (±10 menit)"}
                </Button>
              </div>
            </Card>
            {lastTest && (
              <VakLastTest
                lastTest={lastTest}
                onViewDetail={onViewLastTestDetail}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VakTestIntro;
